import { isNil } from 'lodash';

/**
 * The opposite of lodash isNil, returns true if its NOT null or undefined. This
 * makes it easy to filter arrays because you can just do
 * `[].filter(isPresent);`
 *
 * This is probably also what you want instead of `.filter(Boolean)`
 */
export function isPresent<T>(value: T | null | undefined): value is T {
  return !isNil(value);
}
